export const NEW_CONVERSATION_ID = -1;

export const RECIPIENTS_SEARCH_DEBOUNCE_MILLIS = 200;
export const RECIPIENTS_SEARCH_MIN_QUERY_LENGTH = 1;

export const CLEAR_UNREAD_MESSAGES_LINE_DELAY_MILLIS = 2500;
export const CHECK_FOR_READ_CONVERSATION_THROTTLE_MILLIS = 500;

export const NUDGE_PROCESSING_QUEUE_MAX_SIZE = 50000;

export const MINIMUM_CONVERSATION_LIST_WIDTH_PX = 130;
export const DEFAULT_CONVERSATION_LIST_WIDTH_PX = 266;
export const MINIMUM_MESSAGES_SUBPANEL_WIDTH_PX = 286;
export const PANEL_RESIZE_SEPARATOR_WIDTH = 4;
